var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 20H5C3.35 20 2 18.65 2 17C2 16.45 2.45 16 3 16C3.55 16 4 16.45 4 17C4 17.55 4.45 18 5 18H13C13.55 18 14 17.55 14 17V3C14 2.45 13.55 2 13 2H5C4.45 2 4 2.45 4 3C4 3.55 3.55 4 3 4C2.45 4 2 3.55 2 3C2 1.35 3.35 0 5 0H13C14.65 0 16 1.35 16 3V17C16 18.65 14.65 20 13 20Z",
    fill: "#97E3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11H1C0.45 11 0 10.55 0 10C0 9.45 0.45 9 1 9H11C11.55 9 12 9.45 12 10C12 10.55 11.55 11 11 11Z",
    fill: "#97E3FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.0025 14C3.7425 14 3.4925 13.9 3.2925 13.71L0.2925 10.71C-0.0975 10.32 -0.0975 9.69001 0.2925 9.30001L3.2925 6.30001C3.6825 5.91001 4.3125 5.91001 4.7025 6.30001C5.0925 6.69001 5.0925 7.32001 4.7025 7.71001L2.4125 10L4.7025 12.29C5.0925 12.68 5.0925 13.31 4.7025 13.7C4.5025 13.9 4.2525 13.99 3.9925 13.99L4.0025 14Z",
    fill: "#97E3FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.fc32a52420952f8856a56b77694090df.svg";
export { ForwardRef as ReactComponent };